// extracted by mini-css-extract-plugin
module.exports = {"loader":"_13fQ1"};